import React, { ReactNode } from "react";
import styles from "./AppMessage.scss";

export type MessageType = "INFO" | "ERROR" | "WARNING";

const MessageStyles = {
  INFO: styles.info,
  ERROR: styles.error,
  WARNING: styles.warning,
};

export type AppErreurProps = {
  messageType: MessageType;
  children: ReactNode;
};

const AppMessage = ({ messageType, children }: AppErreurProps) => {
  return <div className={MessageStyles[messageType]}>{children}</div>;
};

export default AppMessage;
